export default "https://cdn.questicon.mathletics.com/assets/images/icon-measure-protractor-7f8aae06dbcb48199a25fbf961f0f966.svg";